import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../theme';
import { Testimonial } from '../types/landing';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

export const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  return (
    <Box
      sx={{
        backgroundColor: colors.softWhite,
        borderRadius: '12px',
        padding: '32px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography
        sx={{
          fontSize: '1rem',
          color: colors.slate[600],
          lineHeight: 1.7,
          fontStyle: 'italic',
          marginBottom: '24px',
          flex: 1,
        }}
      >
        "{testimonial.quote}"
      </Typography>
      <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        <Box
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: colors.deepNavy,
            flexShrink: 0,
            ...(testimonial.avatar && {
              backgroundImage: `url(${testimonial.avatar})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }),
          }}
        />
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              color: colors.deepNavy,
              marginBottom: '4px',
            }}
          >
            {testimonial.name}
          </Typography>
          <Typography
            sx={{
              fontSize: '0.875rem',
              color: colors.slate[600],
              marginBottom: '4px',
            }}
          >
            {testimonial.title}
          </Typography>
          {testimonial.credential && (
            <Typography
              sx={{
                fontSize: '0.75rem',
                color: colors.signalOrange,
                fontWeight: 500,
              }}
            >
              {testimonial.credential}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};
